/**
 * SSR detection helpers
 * Use these to guard browser-only code from running on the server
 */

export const isServer = typeof window === 'undefined'
export const isClient = !isServer

/**
 * Safe wrapper for browser-only code
 * Returns undefined on server, executes callback on client
 */
export function onClient<T>(callback: () => T): T | undefined {
  if (isClient) {
    return callback()
  }
  return undefined
}

/**
 * Safe localStorage access
 * Returns null on server or if localStorage is unavailable
 */
export function safeLocalStorage(): Storage | null {
  if (isClient && typeof localStorage !== 'undefined') {
    return localStorage
  }
  return null
}

/**
 * Safe sessionStorage access
 * Returns null on server or if sessionStorage is unavailable
 */
export function safeSessionStorage(): Storage | null {
  if (isClient && typeof sessionStorage !== 'undefined') {
    return sessionStorage
  }
  return null
}
